import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { Observable, Subject } from 'rxjs';
import { takeUntil ,tap} from 'rxjs/operators';
import { map } from 'rxjs/operators';

// import { UserData } from './users';

@Injectable()
export class AuthGuardService implements CanActivate {
  protected readonly unsubscribe$ = new Subject<void>();
  routerEvents: any;
  currentUrl: string;
  studentTab = '';
  adminTab = '';
  constructor(private authService: NbAuthService,
    private router: Router) {
      this.routerEvents = this.router.events.subscribe(
        (event: any) => {
          if (event instanceof NavigationEnd) {
            var split = event.url.split('/');
            this.currentUrl = split[2];
            
          }
        }
      )
  }
    data: any;
    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
      // // this.studentTab = 'studentDashboard,paidApplication,studentApplication,viewApplication,myApplications,FirstSuccess,FirstCancel,FirstFailure,PaymentSuccess,help,profile,contact-us,faq';
      // this.adminTab = 'dashboard,PendingApplication,SignedApplication,SentApplication,RoleManagement,StudentManagement,TotalApplied,Payments,StudentFeedback,Reports,help,profile,contact-us,faq'
      this.adminTab = 'principle-dashboard,student-management,roleManagement,courseDetails,adminTotal,Sign,emailOrCourier,adminemailed,adminPayment,AdminReport,help,studentFeedback,checkerApplication,errataDocuments,principalApplication,adminView,contact-us,faq,'
      this.studentTab = 'adminEmailTracker,dashboard,paidApplication,studentApplication,viewApplication,myApplications,FirstSuccess,FirstCancel,FirstFailure,PaymentSuccess,help,profile,contact-us,faq';
      let type = route.data["type"] as Array<string>
      
      return this.authService.isAuthenticated()
        .pipe(
          tap(authenticated => {
            if (!authenticated) {
              this.router.navigate(['auth/login']);
            } else {
              this.authService.getToken().pipe(
                map((token: NbAuthJWTToken) => {
                  
                  return token.isValid() ? token.getPayload() : 'guest';
                }),
              ).subscribe(async(user :any) => {
                localStorage.setItem('email', user.email);
                
                
                  if (user.role == 'admin' && user.otp ) {
                    if (this.adminTab.includes(type[0])) {
                    } else {
                      this.router.navigate(['auth/login']);
                    }
                  }else if (user.role == 'admin' ) {
                      this.router.navigate(['auth/adminOtp']);
                  }
                   else if (user.role == 'sub-admin' && user.otp ) {
                    this.data = user.access;
                    if (this.data.includes(type[0])) {                      
                    } else {                      
                      this.router.navigate(['auth/login']);
                    }
                  }else if (user.role == 'sub-admin') {
                      this.router.navigate(['auth/adminOtp']);
                  } else if (user.role == 'student') {
                    if (this.studentTab.includes(type[0])) {
                    } else {
                      this.router.navigate(['auth/login']);
                    }
                  } else {
                    this.router.navigate(['auth/login']);
                  }
                })
            }
          }),
        );
  
    }
  }